import { Modal } from 'antd'
import styled from 'styled-components'

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  }

  .ant-modal-header {
    border-bottom: none;
    padding: 24px 24px 0 24px;
  }

  .ant-modal-title {
    font-weight: 600;
    font-size: 18px;
    color: #1a2b3c;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .ant-modal-body {
    padding: 16px 24px 24px 24px;
    font-size: 15px;
    color: #3d4e5e;
    line-height: 1.6;
  }

  .ant-modal-footer {
    border-top: 1px solid #f0f2f5;
    padding: 16px 24px 24px 24px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .ant-btn {
    border-radius: 40px;
    padding: 6px 24px;
    font-weight: 500;
    height: 40px;
    transition: all 0.2s ease;
  }

  .ant-btn-primary {
    background: #e74c3c;
    border-color: #e74c3c;
    &:hover {
      background: #c0392b;
      border-color: #c0392b;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(231, 76, 60, 0.3);
    }
  }

  .ant-btn-default {
    &:hover {
      border-color: #b0c4d9;
      color: #1a2b3c;
      background: #f8faff;
    }
  }

  .icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #fce9e6;
    border-radius: 50%;
    color: #e74c3c;
    font-size: 24px;
    flex-shrink: 0;
  }
`

export { StyledModal }